import { DeepRequired, FieldErrorsImpl, UseFormRegister, UseFormSetValue } from 'react-hook-form'
import { IOneOfMany } from '@/models'
import { Col, Input, Row, Text } from '@/components/ui'
import s from './question-types.module.scss'

interface RangesQuestionProps {
  question: IOneOfMany
  register: UseFormRegister<any>
  errors: FieldErrorsImpl<DeepRequired<any>>
  setValue: UseFormSetValue<any>
}

const RangesQuestion = ({ question, register, errors, setValue }: RangesQuestionProps) => (
  <Col sm={6}>
    <Row row={10}>
      <Text size='md'>Введите число от 0 до 100</Text>
    </Row>
    <Row row={10}>
      <Input
        name={`${question.id}.value`}
        register={register}
        errors={errors[question.id]}
        onChange={(e) => {
          setValue(`${question.id}.value`, e.target.value)
        }}
        className={s['free-form-answer-input']}
        type='number'
        rules={{
          required: {
            value: true,
            message: 'Заполните поле'
          },
          min: {
            value: 0,
            message: 'Введено недопустимое число'
          },
          max: {
            value: 100,
            message: 'Введено недопустимое число'
          }
        }}
      />
    </Row>
    {errors[question?.id]?.value?.message && (
      <Row>
        <Text size='md' color='danger'>
          {errors[question?.id]?.value?.message?.toString() ?? ''}
        </Text>
      </Row>
    )}
  </Col>
)

export default RangesQuestion
